import { NotificationsState } from "./types";

export const getMessagesSelector = (state: NotificationsState) => state.messages;
